import { render } from "./HelpModal.vue?vue&type=template&id=0345cc1d&scoped=true&ts=true"
import script from "./HelpModal.vue?vue&type=script&lang=ts"
export * from "./HelpModal.vue?vue&type=script&lang=ts"

import "./HelpModal.vue?vue&type=style&index=0&id=0345cc1d&scoped=true&lang=css"

import exportComponent from "/home/runner/work/flowerdiy/flowerdiy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0345cc1d"]])

export default __exports__